import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { MnlSnackbarService } from '@principia-core/monal';
import { filter, map, take } from 'rxjs';
import { SessionService } from '../services/session/session.service';
import { LoggerService } from '../services/logger/logger.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const logger = inject(LoggerService).for('AuthGuard');
  const session = inject(SessionService);
  const router = inject(Router);
  const snackbar = inject(MnlSnackbarService);
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  const toLogin = () => {
    logger.debug({
      message: 'user is not logged in, redirecting to login',
    });
    if (isBrowser) {
      snackbar.show({
        message: 'Please sign in to continue.',
        variant: 'warning',
      });
    }
    return router.createUrlTree(['/login'], {
      queryParams: { redirect: state.url },
    });
  }

  if (!session.isResolving()) {
    logger.debug({
      message: 'session resolved, checking user',
    });
    return session.user() ? true : toLogin();
  }

  const sessionIsResolving$ = toObservable(session.isResolving)

  return sessionIsResolving$.pipe(
    filter((isResolving) => !isResolving),
    take(1),
    map(
      () => {
        logger.debug({
          message: 'session resolved, checking user',
        });
        return session.user() ? true : toLogin();
      }
    ),
  );
};
